import isEmpty from 'lodash/isEmpty';

import PixelService from '@/services/pixel';

import {
  buildLocationHostUrl,
  convertObjectKeys,
  filterObject,
  parseSearchParams,
} from '@/helpers/core';
import { setGtmMarketing } from '@/helpers/gtm';

import {
  MARKETING_PARAMS_MAPPING,
  MARKETING_SEARCH_PARAMS,
  MarketingParam,
} from '@/config/analytics';

function parse(): Dictionary<string> {
  return filterObject(parseSearchParams(window.location.search), MARKETING_SEARCH_PARAMS);
}

function buildLandingParams(params: Dictionary<string>): Dictionary<string> {
  const result = { ...params };

  if (!isEmpty(result)) {
    result[MarketingParam.LANDING_URL] = buildLocationHostUrl();
  }

  return convertObjectKeys(result, MARKETING_PARAMS_MAPPING);
}

function buildPixelParams(): Dictionary<string | null> {
  const { fbc, fbp } = PixelService.getValues();

  return {
    [MarketingParam.FBC]: fbc,
    [MarketingParam.FBP]: fbp,
  };
}

function buildParams(params: Dictionary<string>): Dictionary<string> {
  const result = {};

  Object.assign(result, buildLandingParams(params));
  Object.assign(result, buildPixelParams());

  return result;
}

const params = parse();

PixelService.initCookies(params.fbclid);

const MARKETING_PARAMS = buildParams(params);

setGtmMarketing(MARKETING_PARAMS);

export default MARKETING_PARAMS;
